import { Injectable } from '@angular/core'
import { MatDialogConfig } from '@angular/material/dialog'
import { DialogService } from '@tokeet-frontend/tv3-platform'
import { LosDiscountView } from '@tokeet-frontend/los-discount'
import { AddLosDiscountDialogComponent } from './add-los-discount-dialog.component'

@Injectable()
export class AddLosDiscountDialogService {
  constructor(private dialog: DialogService) {}

  open(data?: { defaults: Partial<LosDiscountView> }) {
    const defaultConfig: MatDialogConfig = {
      width: '800px',
      height: 'auto',
      data: { ...data },
    }

    return this.dialog.openVariableDialog(AddLosDiscountDialogComponent, defaultConfig)
  }
}
